import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/resource", params);
};

const getLookup = () => {
  return restApi.get("/api/resource/lookup");
};

const upsert = data => {
  return restApi.post("/api/resource/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/resource/${ids}`);
};

const getAllForCSV = (params) => {
  return restApi.post("/api/resource/csv", params);
}

const resourceService = {
  getAll,
  getLookup,
  upsert,
  remove,
  getAllForCSV
};

export default resourceService;